import React, { useRef } from "react";
import * as S from "../styles";

const PaperOriginalModal = ({
  isOpen,
  onClose,
  onFileSelect,
  uploading,
  hasOriginal,
}) => {
  const fileInputRef = useRef(null);

  if (!isOpen) return null;

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onFileSelect(file);
    }
    event.target.value = "";
  };

  return (
    <S.ModalOverlay onClick={uploading ? undefined : onClose}>
      <S.Modal onClick={(event) => event.stopPropagation()}>
        <S.ModalTitle>
          {hasOriginal
            ? "Заменить изображение типа бумаги"
            : "Загрузить изображение типа бумаги"}
        </S.ModalTitle>
        <S.OptionButton
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading}
        >
          📁 Выбрать файл
        </S.OptionButton>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        {uploading && <S.Loading>Загрузка...</S.Loading>}
        <p style={{ fontSize: "13px", color: "#888", marginTop: "10px" }}>
          {hasOriginal
            ? "Старый файл будет перемещён в корзину и доступен для отката в журнале."
            : "Изображение будет сохранено и привязано к типу бумаги."}
        </p>
        <S.ModalActions>
          <S.CancelButton onClick={onClose} disabled={uploading}>
            Отмена
          </S.CancelButton>
        </S.ModalActions>
      </S.Modal>
    </S.ModalOverlay>
  );
};

export default PaperOriginalModal;
